// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__182DY","label":"Category_label__2OThy","content":"Category_content__G3hUD","header":"Category_header__3tkAE","location":"Category_location__2qjzG"};